export default __webpack_public_path__ + "static/pig05-87624859290aa9b3d7ad7b401147c6ac.png";